import moment from 'moment-timezone'
import * as React from 'react'

import {
  FinalParentSignUpForm,
  isFinalParentSignUpFormRequired,
} from 'main/components/common/AuthModal'
import { FormGroup } from 'main/components/common/Form'
import { ITour } from 'main/gql/tour'
import { Button, NativeLink, spacing, Strong, Title } from 'main/ui'
import { formatAddress } from 'main/util/address'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { ScheduleTourModal_school, ScheduleTourModal_user } from '../../common/gql'
import SchoolSummary from '../../common/SchoolSummary'
import {
  AddressContainer,
  Container,
  SchoolSummaryContainer,
  TimelineContainer,
} from './Confirmation.styles'
import Timeline from './Timeline'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-CONFIRMATION`
const DATE_TIME_FORMAT = 'dddd, MMMM D, YYYY | h:mma'

interface IProps {
  active: boolean
  school: ScheduleTourModal_school
  tour: ITour
  user: ScheduleTourModal_user
  onRequestCancel: () => void
  onRequestReschedule: () => void
  onComplete: () => void
}

export default function Confirmation(props: IProps) {
  const { active, school, tour, user, onComplete, onRequestCancel, onRequestReschedule } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const { address } = school
  const [date, time] = moment(tour.beginsAt)
    .tz(school.timezone)
    .format(DATE_TIME_FORMAT)
    .split(' | ')

  return (
    <Container>
      <Strong>{t(`${PRE}-TITLE`)}</Strong>
      <div css={{ marginTop: spacing.majorScale(1) }}>
        <Title kind="normal">{date}</Title>
      </div>
      <Title kind="normal">{time}</Title>

      <SchoolSummaryContainer>
        <SchoolSummary
          school={school}
          showPhoto={!active || !isFinalParentSignUpFormRequired(user)}
        />
      </SchoolSummaryContainer>

      {address && (
        <AddressContainer>
          <NativeLink
            href={`https://maps.google.com/?q=${encodeURIComponent(formatAddress(address))}`}
            target="_blank"
          >
            {formatAddress(address)}
          </NativeLink>
        </AddressContainer>
      )}

      <TimelineContainer>
        <Timeline />
      </TimelineContainer>

      {active ? (
        isFinalParentSignUpFormRequired(user) ? (
          <FinalParentSignUpForm
            label="Finalize your profile creation"
            displayPhoneField={false}
            user={user}
            onComplete={onComplete}
          />
        ) : (
          <Button full onClick={onComplete}>
            {t(`${PRE}-DONE`)}
          </Button>
        )
      ) : (
        <FormGroup>
          <Button kind="outline" onClick={onRequestCancel} full>
            {t(`${PRE}-CANCEL`)}
          </Button>
          <Button onClick={onRequestReschedule} full>
            {t(`${PRE}-RESCHEDULE`)}
          </Button>
        </FormGroup>
      )}
    </Container>
  )
}
